var matches = require('matches-selector')

module.exports = function (element, selector, checkYoSelf) {
  var parent = checkYoSelf ? element : element.parentNode

  while (parent && parent !== document) {
    if (matches(parent, selector)) return parent;
    parent = parent.parentNode
  }
}



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/closest/index.js
// module id = ../../node_modules/closest/index.js
// module chunks = 18